import { z } from "zod";

const trimmed = (max: number) => z.string().trim().max(max, `Не длиннее ${max} символов`);

export const SetupBody = z.object({
  login: trimmed(60).min(1, "Укажите логин"),
  name: trimmed(80).optional().default(""),
  password: z.string().min(6, "Пароль — не короче 6 символов").max(200),
});

export const LoginBody = z.object({
  login: trimmed(60).min(1, "Укажите логин"),
  password: z.string().min(1, "Укажите пароль").max(200),
});

export const PasswordBody = z.object({
  current: z.string().max(200).optional().default(""),
  next: z.string().min(6, "Новый пароль — не короче 6 символов").max(200),
});

/** Поля проекта без значений по умолчанию — для частичной правки (в zod 4 default срабатывает и внутри .partial()). */
const projectFields = {
  name: trimmed(120).min(1, "Укажите название проекта"),
  description: trimmed(20000),
  rubric: trimmed(300),
  footer: trimmed(2000),
  hashtags: trimmed(500),
  style_notes: trimmed(5000),
};

export const ProjectBody = z.object({
  name: projectFields.name,
  description: projectFields.description.optional().default(""),
  rubric: projectFields.rubric.optional().default(""),
  footer: projectFields.footer.optional().default(""),
  hashtags: projectFields.hashtags.optional().default(""),
  style_notes: projectFields.style_notes.optional().default(""),
});

export const ProjectPatch = z.object(projectFields).partial().extend({
  archived: z.boolean().optional(),
});

export const PostCreate = z.object({
  project_id: z.number().int().positive().nullable().optional(),
});

export const PostUpdate = z.object({
  text: z.string().max(16000, "ВКонтакте не примет пост длиннее 16 000 символов").optional(),
  title: trimmed(200).optional(),
  project_id: z.number().int().positive().nullable().optional(),
  image_prompt: z.string().max(4000).nullable().optional(),
});

export const MessageBody = z.object({
  text: z.string().trim().min(1, "Напишите, что произошло или что поправить").max(12000),
});

export const ImageGenerateBody = z.object({
  prompt: z.string().trim().max(4000).optional(),
});

export const ImageOrderBody = z.object({
  ids: z.array(z.number().int().positive()).max(20),
});

export const PublishBody = z.object({
  /** секунды unix; нет — через 30 минут (всегда отложенная запись во ВК) */
  at: z.number().int().positive().optional(),
});

export const AutoGenerateBody = z.object({
  kind: z.enum(["any", "news", "fact", "myth"]).default("any"),
  count: z.number().int().min(1).max(3).default(1),
  hint: trimmed(500).optional().default(""),
});

export const SettingsPatch = z
  .object({
    vk_group_id: z
      .string()
      .trim()
      .regex(/^\d{1,12}$/, "ID сообщества — это число"),
    vk_group_name: trimmed(120),
    vk_client_id: z
      .string()
      .trim()
      .regex(/^\d{1,12}$/, "ID приложения — это число"),
    gemini_key: z.string().trim().max(300),
    gemini_model: trimmed(120).min(1),
    auto_generate_images: z.boolean(),
    claude_model: trimmed(120),
    auto_enabled: z.boolean(),
    auto_interval_days: z.number().int().min(1).max(30),
    auto_hour: z.number().int().min(0).max(23),
    timezone: trimmed(64).min(1),
    auto_news_count: z.number().int().min(0).max(5),
    auto_fact_count: z.number().int().min(0).max(5),
    auto_myth_count: z.number().int().min(0).max(5),
  })
  .partial();
export const VkPasteBody = z.object({
  url: z.string().trim().min(1, "Вставьте адрес со страницы после входа").max(5000),
});

export const GroupTokenBody = z.object({
  value: z.string().trim().max(500),
});

export type SetupBodyT = z.infer<typeof SetupBody>;
export type ProjectBodyT = z.infer<typeof ProjectBody>;
export type ProjectPatchT = z.infer<typeof ProjectPatch>;
export type PostUpdateT = z.infer<typeof PostUpdate>;
export type AutoGenerateBodyT = z.infer<typeof AutoGenerateBody>;
export type SettingsPatchT = z.infer<typeof SettingsPatch>;
